"use client";
import { createContext as u, useContext as m } from "react";
function C(r = {}) {
  const {
    // Если strict = true, выбросим ошибку при отсутствии контекста
    strict: c = !0,
    // Сообщение об ошибке по умолчанию
    errorMessage: a = `${r.name}: \`context\` is undefined. Seems you forgot to wrap component within the Provider`,
    // Отображаемое имя контекста в React DevTools
    name: s
  } = r, t = u(void 0);
  t.displayName = s;
  function i() {
    var n;
    const o = m(t);
    if (!o && c) {
      const e = new Error(a);
      throw e.name = "ContextError", (n = Error.captureStackTrace) == null || n.call(Error, e), e;
    }
    return o;
  }
  return [t, i];
}
export {
  C as createCustomContext
};
